export default {"src":"/_next/static/media/icon-error.7c4f7524.svg","height":16,"width":16};